import TransacoesPage from './TransacoesPage';
export default function FinancasSaidas() {
  return <TransacoesPage tipo="saida" titulo="Saídas" descricao="Despesas, custos e fornecedores" />;
}
